const TEXT_PROPS = {
  lineHeight: 1.35,
  fontWeight: "normal",
  fontVariant: "normal",
  fontStyle: "normal",
  padding: "0px"
};
const STROKE_SIZES = {
  s: 2,
  m: 3.5,
  l: 5,
  xl: 10
};
const FONT_SIZES = {
  s: 16,
  m: 28,
  l: 48,
  // Previously, we used XL as the default size for text shapes.
  // After adding text size options for users, we only offer (S,M,L) with L as the default size.
  // Make L and XL the same size so it's easy to map the old text shapes with XL to the new L.
  xl: 48
};
const LABEL_FONT_SIZES = {
  s: 16,
  m: 28,
  l: 48,
  xl: 48
};
const ARROW_LABEL_FONT_SIZES = {
  s: 16,
  m: 28,
  l: 48,
  xl: 48
};
const FONT_FAMILIES = {
  draw: "var(--tl-font-draw)",
  sans: "var(--tl-font-sans)",
  serif: "var(--tl-font-serif)",
  mono: "var(--tl-font-mono)"
};
const LABEL_TO_ARROW_PADDING = 20;
const ARROW_LABEL_PADDING = 4.25;
const LABEL_PADDING = 16;
export {
  ARROW_LABEL_FONT_SIZES,
  ARROW_LABEL_PADDING,
  FONT_FAMILIES,
  FONT_SIZES,
  LABEL_FONT_SIZES,
  LABEL_PADDING,
  LABEL_TO_ARROW_PADDING,
  STROKE_SIZES,
  TEXT_PROPS
};
//# sourceMappingURL=default-shape-constants.mjs.map
